export default __webpack_public_path__ + "static/jvc-150-fund-ca-promo-final-tamil-92b45e5709ae413d8385bf89012d104b.png";